import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/cover_photo.jpg'


const _withScopeId = n => (_pushScopeId("data-v-22d3f715"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "ion-text-center ion-padding-bottom" }, "設計訂造", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ion-text-center ion-padding-bottom" }, "專屬您的寵物保鮮花", -1))
const _hoisted_3 = { class: "ion-margin-top" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 重新開始設計 ")
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return ($props.homeBanners)
    ? (_openBlock(), _createBlock(_component_swiper, {
        key: 0,
        pagination: false,
        slidesPerView: 1,
        autoplay: { delay: 8000 },
        speed: 1000,
        loop: false,
        autoHeight: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_swiper_slide, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _hoisted_2,
              _createElementVNode("img", {
                class: "main-img",
                src: _imports_0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openImageModal(require('@/assets/cover_photo.jpg'))))
              }),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_ion_button, {
                  color: "primary",
                  shape: "round",
                  size: "large",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openDesignPreQuestionModal()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($setup.newDesign.bottle.id ? '繼續之前的設計' : '馬上開始訂造') + " ", 1),
                    _createVNode(_component_ion_icon, {
                      slot: "end",
                      icon: $setup.enterOutline
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }),
                _createElementVNode("p", null, [
                  _withDirectives(_createVNode(_component_ion_button, {
                    color: "medium",
                    fill: "outline",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openDesignPreQuestionModal(true)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh
                      }, null, 8, ["icon"]),
                      _hoisted_4
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, $setup.newDesign.bottle.id]
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : ($props.banners)
      ? (_openBlock(), _createBlock(_component_swiper, {
          key: 1,
          pagination: false,
          slidesPerView: 1,
          autoplay: $setup.bannerOps.autoplay,
          speed: $setup.bannerOps.speed,
          loop: true,
          autoHeight: false
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.banners, (banner) => {
              return (_openBlock(), _createBlock(_component_swiper_slide, {
                key: banner.id,
                onClick: ($event: any) => ($setup.openImageModal(banner.imageLink, '', true))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "banner-img",
                    src: banner.imageLink
                  }, null, 8, _hoisted_5)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["autoplay", "speed"]))
      : ($props.hidePagination)
        ? (_openBlock(), _createBlock(_component_swiper, {
            key: 2,
            grabCursor: true,
            slidesPerView: 3.1,
            spaceBetween: 10,
            breakpoints: $setup.bannerOps.breakpoints,
            autoHeight: true
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.photoLinks, (link) => {
                return (_openBlock(), _createBlock(_component_swiper_slide, {
                  key: link,
                  onClick: ($event: any) => ($setup.openImageModal(link))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      class: "slide-img",
                      src: link
                    }, null, 8, _hoisted_6)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["slidesPerView", "breakpoints"]))
        : (_openBlock(), _createBlock(_component_swiper, {
            key: 3,
            class: "display-slides",
            grabCursor: true,
            pagination: {
      clickable: true
    },
            slidesPerView: 2.5,
            spaceBetween: 10,
            breakpoints: $setup.bannerOps.breakpoints,
            autoplay: $setup.bannerOps.autoplay,
            speed: $setup.bannerOps.speed,
            loop: true,
            autoHeight: true
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.photoLinks, (link) => {
                return (_openBlock(), _createBlock(_component_swiper_slide, {
                  key: link,
                  onClick: ($event: any) => ($setup.openImageModal(link))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      class: "slide-img",
                      src: link
                    }, null, 8, _hoisted_7)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["slidesPerView", "breakpoints", "autoplay", "speed"]))
}